export const ENDPOINTS = {
  dashboards: {
    list: (siteId: string) => `/Dashboards/${siteId}`,
    get: (siteId: string, dashboardId: string) => `/Dashboards/${siteId}/${dashboardId}`,
  },
  liveDashboards: {
    list: (siteId: string) => `/Sites/${siteId}/LiveDashboards`,
  },
  organizations: {
    list: '/Organizations',
    user: '/Organizations/user',
    sites: {
      list: (organizationId: string) => `/Organizations/${organizationId}/Sites`,
    },
  },
  qualityTestExecutions: {
    getTestHistory: (siteId: string, testId: string) => `/api/quality-test-executions/${siteId}/${testId}/history`,
    get: (siteId: string, executionId: string) => `/api/quality-test-executions/${siteId}/${executionId}`,
    submit: (siteId: string, versionId: string) => `/api/quality-test-executions/${siteId}/${versionId}`,
    softDelete: (siteId: string, executionId: string) =>
      `/api/quality-test-executions/${siteId}/${executionId}/soft-delete`,
    restore: (siteId: string, executionId: string) => `/api/quality-test-executions/${siteId}/${executionId}/restore`,
  },
  qualityTests: {
    list: (siteId: string) => `/api/quality-tests?siteId=${siteId}`,
    get: (siteId: string, id: string) => `/api/quality-tests/${siteId}/${id}`,
  },
  qualityControl: {
    attachments: {
      upload: (siteId: string) => `/api/quality-control/${siteId}/attachments`,
      delete: (siteId: string) => `/api/quality-control/${siteId}/attachments`,
      proxy: (siteId: string) => `/api/quality-control/${siteId}/attachments/proxy`,
    },
  },
  reports: {
    list: (siteId: string, isAdminOnly?: boolean) => `/Reports/${siteId}${isAdminOnly ? '?isAdminOnly=True' : ''}`,
    adminList: `/Reports/admin`,
    get: (workspaceId: string, reportId: string) => `/Reports/${workspaceId}/${reportId}`,
    usage: () => `/Reports/usage`,
    favorites: {
      list: (siteId: string) => `/Reports/${siteId}/Favorites`,
      add: (siteId: string, reportId: string) => `/Reports/${siteId}/Favorites/${reportId}`,
      remove: (siteId: string, reportId: string) => `/Reports/${siteId}/Favorites/${reportId}`,
    },
  },
  resourceReports: {
    list: (siteId: string) => `/ResourceReport/sites/${siteId}`,
    get: (siteId: string, resourceId: string) => `/ResourceReport/${siteId}/${resourceId}`,
    blobProxy: (siteId: string) => `/ResourceReport/${siteId}/BlobStorage/proxy`,
  },
  sites: {
    createToken: (siteId: string) => `/Sites/${siteId}/ApiTokens`,
    users: {
      list: (siteId: string) => `/Sites/${siteId}/Users`,
      assign: (siteId: string) => `/Sites/${siteId}/Users`,
      remove: (siteId: string, userId: string) => `/Sites/${siteId}/Users/${userId}`,
    },
    get: (siteId: string) => `/Sites/${siteId}`,
    getProductLicenses: (siteId: string) => `/Sites/${siteId}/activeLicenses`,
  },
  siteActiveLicenses: {
    list: (siteId: string) => `/SiteActiveLicenses/${siteId}`,
  },
  users: {
    updateLastVisitedSite: `/Users/lastVisitedSite`,
    updateOnboarding: `/Users/onboarding`,
  },
}
